
import { GET_ALL_RECORDS, GET_TIME_LOGS } from "../../Queries/Reports";
import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from "../..";
import { GET_CLIENTDETAILS_BY_ID } from "../../Queries/Orders";
import { createSlice } from "@reduxjs/toolkit";
import { setLoader } from "../loaderSlice";

const processOverrideHistory = (overrides) => {
  return overrides?.flatMap((override) => {
    const {
      previousstartTime,
      previousendTime,
      previousTask,
      updatedTime,
      overriddenBy,
    } = override;

    const result = [];

    const isValid = (value) =>
      value !== "No Change" &&
      value !== null &&
      value !== undefined &&
      value?.trim() !== "";

    const hasValidTask = isValid(previousTask);
    const hasValidStart = isValid(previousstartTime);
    const hasValidEnd = isValid(previousendTime);

    if (hasValidTask) {
      const [prev, curr] = previousTask?.split(" ==> ");
      result?.push({
        overriddenBy,
        changedArea: 'Client Info',
        updatedTime,
        previousTask: prev,
        currentTask: curr,
      });
    }

    if (hasValidStart) {
      const [prev, curr] = previousstartTime.split(" ==> ");
      result.push({
        overriddenBy,
        changedArea: 'Timer information',
        updatedTime,
        previousTask: prev,
        currentTask: curr,
      });
    }

    if (hasValidEnd) {
      const [prev, curr] = previousendTime.split(" ==> ");
      result.push({
        overriddenBy,
        changedArea: 'Timer Information',
        updatedTime,
        previousTask: prev,
        currentTask: curr,
      });
    }

    return result;
  });
};

const multipleDate = (data) => {

  const transformedData = data?.flatMap((data, dataIdx) => {
    const overrides = Array.isArray(data.overrideHistory)
      ? data.overrideHistory
      : [data.overrideHistory];

    const newOverridesHistory = processOverrideHistory(overrides);

    return newOverridesHistory?.map((override, index) => {
      const {
        overriddenBy,
        previousTask,
        currentTask,
        changedArea,
        updatedTime,
      } = override;

      const { firstname, lastname, email } = data.employeeDetails || {};
      const uniqueId = [
        data.userId || 'u',
        data.requestId || 'r',
        dataIdx,
        index
      ].join('_');

      return {
        id: uniqueId,
        userId: data.userId,
        requestId: data.requestId,
        clientName: data.clientName,
        taskType: data.taskType,
        department: data.department,
        startTime: data.startTime,
        endTime: data.endTime,
        updatedAt: data.updatedAt,
        overriddenBy,
        changedArea,
        updatedTime,
        previousTask,
        currentTask,
        firstname,
        lastname,
        email,
      };
    });
  });

  return transformedData;
};


export const GetAllRecords = createAsyncThunk(
  'records/getAll',
  async (form, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true))
      const response = await client.query({
        fetchPolicy: "network-only",
        query: GET_ALL_RECORDS,
        variables: { input: form },
      });
      dispatch(setRecords(response.data?.GetAllRecords));
      dispatch(setLoader(false));
      return response.data;
    } catch (err) {

      return rejectWithValue(err.message || "Failed to fetch records");
    }
  }
);

export const GetTimeReports = createAsyncThunk(
  'timeReports/get',
  async (form, { dispatch, rejectWithValue }) => {
    try {
      dispatch(setLoader(true))
      const response = await client.query({
        fetchPolicy: "network-only",
        query: GET_TIME_LOGS,
        variables: {
          from: form.from,
          page: form.page,
          to: form.to,
          startOfMonth: form.startOfMonth,
          endOfMonth: form.endOfMonth,
        },
      });
      const data = multipleDate(response.data?.GetTimeRecord?.records)
      dispatch(setRecords(data));
      dispatch(setLoader(false))
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch records");
    } finally {
      dispatch(setLoader(false));
    }
  }
);





export const GetClientById = createAsyncThunk(

  'clientReports/getById',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await client.query({
        fetchPolicy: "network-only",
        query: GET_CLIENTDETAILS_BY_ID,
        variables: { id },
      });

      return response.data?.getClientsDetails;
    } catch (err) {
      return rejectWithValue(err.message || "Failed to fetch records");
    }
  }

)

const initialState = {
  clientProfile: {},
  loading: false,
  error: null,
};

const reportSlice = createSlice({
  name: "client",
  initialState,
  AllRecords: {},
  reducers: {

    setRecords(state, action) {
      state.AllRecords = action.payload
    },
  },
  extraReducers: (builder) => {
    builder

      .addCase(GetClientById.fulfilled, (state, action) => {
        state.loading = false;
        state.clientProfile = action.payload;
      })

  },
});
export const {
  setRecords
} = reportSlice.actions;
export default reportSlice.reducer;



